export default "__VITE_ASSET__BLISEKW8__"